import dayjs from 'dayjs';

import { LOCALE } from '@constants';

import 'dayjs/locale/es';

dayjs.locale(LOCALE.ES);
